import { useFela } from 'react-fela';
import { FormattedMessage } from 'react-intl';
import Spin from 'antd/lib/spin';

import rule from './MapLoader.rule';

const MapLoader = () => {
    const { css } = useFela();
    return (
        <div className={css(rule)}>
            <Spin tip={<FormattedMessage id="maps.googleMap.loader" />} />
        </div>
    );
};

export default MapLoader;
